import axios from "axios";

export const BASE_URL = "https://cricketapi.sindoor7.com/api/v1";

export const FILE_BASE_URL = "https://cricketapi.sindoor7.com/";

export const getSlider = () => {
  return axios.get(`${BASE_URL}/websiteslider/guest`);
};

export const webDetails = (data) => {
  return axios.get(`${BASE_URL}/website`, data);
};

export const serviceCategory = (data) => {
  return axios.get(`${BASE_URL}/website/service-category`, data);
};